import { FC, useEffect } from 'react';
import useNoodleApi from '@hooks/useNoodleApi';
import ProgressIndicator from '@components/ProgressIndicator';
import Buttons from '@components/Buttons/Buttons';
import s from '@components/CartTermsForm/CartTermsForm.module.scss';
import Spacer from '@components/Spacer';
import DOMPurify from 'isomorphic-dompurify';
import createCustomTerms from '@tsClient/customTerms/createCustomTerms';

type Props = {
  termsTemplateId: string;
  personId: string;
  priceId: string;
  templateFieldsData: Record<string, unknown>;
  onFinish?: () => void;
  setCustomTermsId: (customTermsId: string) => void
};

const CartTermsForm: FC<Props> = ({
  priceId,
  personId,
  termsTemplateId,
  templateFieldsData,
  onFinish,
  setCustomTermsId,
}) => {
  const { data: termsData, fetchingState: fetchingTerms, getData: getTermsFn } = useNoodleApi(createCustomTerms);
  useEffect(() => {
    getTermsFn({
      data: templateFieldsData,
      personId,
      priceId,
      termsTemplateId,
    });
  }, [getTermsFn, priceId, templateFieldsData, personId, termsTemplateId]);

  useEffect(() => {
    if (termsData?.id) {
      setCustomTermsId(termsData.id);
    }
  }, [termsData, setCustomTermsId]);

  return (
    <div className={s.terms}>
      <h1 className="heading-sm">Terms of Service</h1>
      <Spacer size={12} />
      {fetchingTerms.isFetching && <ProgressIndicator isCentered />}
      {termsData?.termsText && (
        <div
          className={s.terms__text}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(termsData?.termsText.replace(/<p\s*>\s*<\/p>/g, '<br>')) }}
        />
      )}
      {onFinish && (
        <>
          <Spacer size='32px' />
          <Buttons isSecondary isFullWidth onClick={onFinish}>
            Agree and continue
          </Buttons>
        </>
      )}
    </div>
  );
};

export default CartTermsForm;
